import {  dashboardConstants } from 'Constants/dashboard.constants';
import Request from 'Services/request';
import { queryParser } from 'Helpers/urlform'
import { handleApiError } from 'Helpers/index';

const dummyDashBoardData = {
  data: [ {
    currentUsers: 1,
    ldapUsers: 2,
    newUsers: {
      today: 3,
      thisweek: 4,
      thismonth: 5,
    },
    messagesSent: {
      text: 9,
      multimedia: 10,
    },
    audioCall: {
      minutes: 11,
      calls: 12,
    },
    videoCall: {
      minutes: 13,
      calls: 14,
    },
    groupCount: 15,
    broadcastCount: 16,
    usersByPlatform: {
      web: 17,
      android: 18,
      ios: 19,
    },
    unreadFeedbackCount: 20,
  } ]
}

const requestDashboard = dashboard =>({ 
    type: dashboardConstants.DASHBOARD_REQUEST, 
    dashboard 
})

const successDashboard = dashboardObj =>({
    id: Date.now(),
    type: dashboardConstants.DASHBOARD_GET_SUCCESS,
    dashboard:dashboardObj,
})

const failureDashboard = error =>({
    type: dashboardConstants.DASHBOARD_FAILURE,
    error
})

function fetchDashboard(SearchArray) {
  let url = '/dashboard';
  if(SearchArray && SearchArray.length > 0 ) {
    url = queryParser(url,SearchArray);
  }  
  return async (dispatch) => {
    dispatch(requestDashboard({}));
    await Request.get(url, {})
      .then(( response ) => {
        const { data } = response;
        dispatch(successDashboard({ data }));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureDashboard(error.toString()));
        }
      });
  };
}

export const DashboardAction = {
    fetchDashboard,
}